// The client record and the app-shell calls every page makes.
import { DEMO_CLIENT, iso, today, addDays } from '../client';

const clientRecord = () => ({
  id: DEMO_CLIENT.id,
  name: DEMO_CLIENT.name,
  dba_name: null,
  slug: DEMO_CLIENT.slug,
  status: DEMO_CLIENT.status,
  fees: DEMO_CLIENT.fee_pct / 100, // fraction: the dashboard does spend * (1 + fees)
  fee: DEMO_CLIENT.fee_pct,
  brand_color: '#1F5F8B',
  client_logo_file: null,
  client_logo_url: null,
  parent_company: null,
  parent_company_name: null,
  parent_company_logo_file: null,
  last_backend_update: `${iso(addDays(today(), -1))}T06:12:00Z`,
  website: DEMO_CLIENT.website,
  timezone: DEMO_CLIENT.timezone,
  billing_frequency: 'bi_weekly',
  payment_terms: 7,
  funding_model: 'guru_funds_spend',
});

const isDemoClientKey = (key) => [String(DEMO_CLIENT.id), DEMO_CLIENT.slug].includes(String(key));

export { clientRecord };

export const routes = [
  ['GET', 'dashboard/clients/:key', ({ match }) => (isDemoClientKey(match.key) ? clientRecord() : { __status: 404, body: { detail: 'Not found.' } })],
  ['GET', 'dashboard/clients', () => {
    const rows = [clientRecord()];
    return { results: rows, count: rows.length, next: null, previous: null };
  }],
  ['GET', 'dashboard/notifications/unread-count', () => ({ count: 2, unread_count: 2 })],
  // Settings "Save" swaps the response in as the signed-in user, so hand
  // back the staff user unchanged rather than a bare "not saved" body.
  ['PATCH', 'accounts/auth/user', () => {
    try {
      return JSON.parse(window.localStorage.getItem('auth') || '{}').user || {};
    } catch {
      return {};
    }
  }],
];
